<template>
	<div id="footer">
		<!-- <div class="friendship_links">
			<div class="address_tel_fax">
				<div class="main-box" v-for="(item, index) in 4" :key="index" @mouseenter="handleMouseEnter(index)"
					@mouseleave="handleMouseLeave">
					主元素 {{ index + 1 }}
					
					<div v-show="activeIndex === index" class="float-box" @mouseenter="clearHideTimer"
						@mouseleave="handleMouseLeave">
						悬浮层内容 {{ index + 1 }}<br>
						鼠标移到这里不会消失哦~
					</div>
				</div>
			</div>
		</div> -->
		<div class="company">
			<div class="info4">
				<div>
					{{info.webName}}
				</div>
				<div>
					{{info.address}}   {{info.phone}} 传真：{{info.czNum}}
				</div>
				<div>
					<img class="logo" src="@/assets/img/foot_logo.png" alt="" />
					备案号：{{info.icpNum}}
				</div>
			</div>
			<div class="gzg_info">
				<img src="@/assets/img/logo_4.png" alt="" />
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	export default {
		name: "Footer",
		data() {
			return {
				activeIndex: -1, // 当前激活的主元素索引（-1表示无）
				hideTimer: null, // 存储延迟隐藏的定时器
				info: '',
				domain: '',
			};
		},
		mounted() {
			// 如果需要包含协议，可以这样组合
			this.domain = `${window.location.protocol}//${window.location.hostname}`;
			this.getInfo()
		},
		methods: {
			// 鼠标进入主元素：显示悬浮层
			handleMouseEnter(index) {
				this.clearHideTimer(); // 清除之前的延迟定时器
				this.activeIndex = index;
			},

			// 鼠标离开主元素/悬浮层：延迟隐藏悬浮层
			handleMouseLeave() {
				this.hideTimer = setTimeout(() => {
					this.activeIndex = -1;
				}, 100); // 短延迟，避免鼠标过渡时误隐藏
			},

			// 鼠标进入悬浮层：清除延迟定时器（阻止隐藏）
			clearHideTimer() {
				if (this.hideTimer) {
					clearTimeout(this.hideTimer);
					this.hideTimer = null;
				}
			},
			getInfo() {
				// 发起 POST 请求
				axios.post('/index/webSite')
					.then(response => {
						console.log('响应数据:', response.data);
						this.info = response.data.data
					})
					.catch(error => {
						console.error('请求出错:', error);
					});
			},
		}
	};
</script>
<style scoped>
	#footer {
		height: 240px;
		transition: all ease 0.6s;
		background: #424242;
		box-sizing: border-box;
		text-align: left;
	}

	.friendship_links {
		height: 70px;
		background-color: #FAFAFA;
	}

	.friendship_links .address_tel_fax {
		position: relative;
		width: 1120px;
		height: 100%;
		line-height: 70px;
		margin: 0 auto;
		/* background-color: red; */
		display: flex;
		justify-content: space-around;
	}

	.main-box {

		/* 为悬浮层绝对定位做准备 */
		cursor: pointer;
		transition: background 0.3s;
	}

	.main-box:hover {
		background: #e8e8e8;
	}

	.float-box {
		position: absolute;
		top: -70px;
		left: 0px;
		width: 1120px;
		height: 60px;
		background: rgba(0, 123, 255, 0.9);
		color: white;
		border-radius: 4px;
		padding: 20px;
		box-sizing: border-box;
		z-index: 10;
	}

	.company {
		width: 1120px;
		margin: 0 auto;
		/* height: 277px; */
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #3F3F3F;
	}

	.record {
		height: 80px;
		box-sizing: border-box;
		background: #424242;
		padding: 20px;
		font-size: 12px;
		color: #B2BFCD;
		display: flex;
		justify-content: space-around;
		text-align: center;
	}



	.gzg_info img {
		width: 286px;
		height: 50px;
		margin-top: 100px;
	}

	.gzg_info {
		text-align: center;
	}

	.gzg_info div {
		color: #B2BFCD;
		font-size: 14px;
		margin-top: 15px;
	}

	.record img {
		width: 36px;
		height: 40px;
		display: inline-block;
	}



	.record span {
		margin-left: 14px;
	}

	.info,
	.info4 {
		margin-top: 50px;

	}

	.logo {
		display: inline-block;
		width: 66px;
		margin-right: 20px;
	}

	.info div,
	.info4 div {
		line-height: 45px;
		color: #FFFFFF;
		font-size: 14px;
	}


	@media screen and (min-width:998px) {
		.company {
			height: 240px;
		}

	}



	@media screen and (max-width: 997px) {
		.title {
			font-size: 20px;
		}

		.address_tel_fax {
			font-size: 12px;
		}

		.email_wx {

			font-size: 12px;
		}

		.copy {
			font-size: 12px;
			margin: 30px 0 10px;
		}

		.info {
			display: none;
		}

		.info4 {
			margin-top: 0px;
		}

		.company {
			width: 90%;
			padding: 30px 0;
			/* height: 220px; */
		}

		#footer {
			height: 240px;
		}

		.gzg_info {
			display: none;
		}


	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue